import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import styles from "./Checkbox.module.css";
export const Checkbox = ({ checked, onChange, label, disabled = false, size = "md", className = "", id, name, "data-testid": testId, }) => {
    const handleChange = useCallback(() => {
        if (!disabled) {
            onChange(!checked);
        }
    }, [checked, disabled, onChange]);
    const handleKeyDown = useCallback((e) => {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            handleChange();
        }
    }, [handleChange]);
    return (_jsxs("label", { className: `${styles.checkboxWrapper} ${disabled ? styles.disabled : ""} ${className}`, "data-testid": testId, children: [_jsx("input", { type: "checkbox", className: styles.hiddenInput, checked: checked, onChange: handleChange, disabled: disabled, id: id, name: name, onKeyDown: handleKeyDown }), _jsx("span", { className: `${styles.checkbox} ${styles[size]} ${checked ? styles.checked : ""}`, children: _jsx("svg", { className: `${styles.checkmark} ${styles[size]}`, viewBox: "0 0 12 12", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("polyline", { points: "2 6 5 9 10 3" }) }) }), label && (_jsx("span", { className: `${styles.label} ${styles[size]}`, children: label }))] }));
};
